import React, { useState, useMemo } from 'react'
import { Document, Page } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'
import { Spin, Alert } from 'antd'
import { pdfjs } from 'react-pdf'

// It's recommended to set this up once globally, e.g., in your app's entry point.
// However, for a self-contained component, we can pass workerSrc via options.
const PDF_WORKER_SRC = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

// Set the workerSrc for pdfjs globally when this module loads.
// This is crucial for react-pdf to find the worker.
pdfjs.GlobalWorkerOptions.workerSrc = PDF_WORKER_SRC

const PdfViewer = ({ file, isLoading, error, onError, width }) => {
    const [numPages, setNumPages] = useState(null)

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages)
    }

    function onDocumentLoadError(loadError) {
        console.error('PdfViewer: Failed to load PDF document:', loadError)
        if (onError) {
            onError(loadError)
        }
    }

    const documentOptions = useMemo(() => ({
        workerSrc: PDF_WORKER_SRC,
    }), [])

    const loadingSpinner = (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', marginTop: '240px' }}>
            <Spin spinning size='large' />
        </div>
    );

    if (isLoading) return loadingSpinner

    if (error) {
        return <Alert message='Error loading PDF' description={error.data?.message || error.status?.toString() || 'Unknown error'} type='error' showIcon />
    }

    if (!file) {
        return <Alert message='No PDF file provided or PDF will be loaded here' type='info' showIcon />
    }

    return (
        <Document
            file={file}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            options={documentOptions}
            style={{ flexGrow: 1, overflowY: 'auto', width: '100%' }}
            loading={loadingSpinner}
        >
            {Array.from(new Array(numPages || 0), (el, index) => (
                <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={true}
                    renderAnnotationLayer={false}
                    width={width}
                    className="pdf-page-container"
                    loading={loadingSpinner}
                />
            ))}
        </Document>
    )
}

export default PdfViewer 